import React, { useState } from 'react';
import { Card, Form, Input, Button, Alert, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../services/apiClient';
import { extractApiErrorMessage } from '../../utils/errorHandler';

const ChangePassword: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      const response = await apiClient.post('/api/auth/change-password', {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      });

      if (response.data.success) {
        message.success('密碼修改成功，請重新登入');
        // Clear auth data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        delete apiClient.defaults.headers.common['Authorization'];
        
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (error: any) {
      const errorMessage = extractApiErrorMessage(error, '密碼修改失敗');
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <Card title="修改密碼">
        <Alert
          message="密碼安全要求"
          description="新密碼必須至少6位，建議包含大小寫字母和數字。"
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
        />

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="舊密碼"
            name="oldPassword"
            rules={[{ required: true, message: '請輸入舊密碼' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="請輸入舊密碼"
            />
          </Form.Item>

          <Form.Item
            label="新密碼"
            name="newPassword"
            rules={[
              { required: true, message: '請輸入新密碼' },
              { min: 6, message: '密碼長度至少6位' },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="請輸入新密碼"
            />
          </Form.Item>

          <Form.Item
            label="確認新密碼"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: '請確認新密碼' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('兩次輸入的密碼不一致'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="請再次輸入新密碼"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              確認修改
            </Button>
          </Form.Item>

          <Form.Item>
            <Button type="default" onClick={() => navigate(-1)} block>
              取消
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePassword;